export default __webpack_public_path__ + "static/media/swelling-around-the-vagina.e446dd10.png";